import { BalloonContentType } from '@src/app/modules/map';

import { LoyaltyProgramListProduct } from '../models';

/**
 * Утилита для получения меток на карте из элемента списка продуктов
 *
 * @param {LoyaltyProgramListProduct} product Объект элемента списка продуктов
 * @param {string | undefined} unionId
 */
export const getBalloonContentByProductList = (
  product: LoyaltyProgramListProduct,
  unionId?: string,
): Array<BalloonContentType> => {
  const link = '/loyalty/product/' + product.id + (unionId ? `?unionId=${unionId}` : '');

  return (
    product.mapObjects?.map(item => {
      return <BalloonContentType>{
        link,
        name: product.name,
        description: product.descriptionShort,
        address: item.address,
        geometry: {
          latitude: item.latitude,
          longitude: item.longitude,
        },
      };
    }) ?? []
  );
};
